import axios from "@/plugins/axios";

let url = "/api/console/dashboard";

export default {
    day(data){
        return axios.get(`${url}/day`, data).then(result => result.data);
    },

    month(data){
        return axios.get(`${url}/month`, data).then(result => result.data);
    },
}
